export const currentLessonSelector = (state: any) => state.currentLesson;
